/**
 * Runtime configuration. Everything the app needs from the environment lives
 * here, so no module reads import.meta.env directly.
 */

const raw = import.meta.env;

export const env = {
	/** Gateway base URL. Same-origin in production via a proxy/route rule. */
	apiBaseUrl: (raw.VITE_API_BASE_URL as string) ?? "http://localhost:3002",
	isDev: raw.DEV,
} as const;
